module.exports = __webpack_public_path__ + "img/ROU.710fb4c4.png";